import { render, staticRenderFns } from "./VinylFrostingWallpaper.vue?vue&type=template&id=91215124&scoped=true&"
import script from "./VinylFrostingWallpaper.vue?vue&type=script&lang=ts&"
export * from "./VinylFrostingWallpaper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91215124",
  null
  
)

export default component.exports